import React, {useEffect} from 'react';
import {usePulsoidClient} from '../../../PulsoidClient';
import buildUrl from 'build-url';
import {ButtonV2} from '../../../system/ButtonV2/ButtonV2';
import set from 'lodash/set';
import {Form, Spinner} from 'react-bootstrap';
import {BasicFormElement} from '../../../system/form';
import {Action} from '../../../system/buttons';

type Props = {
  configuration: any;
  onUpdate: (config: any) => void;
  token: string;
  onSave: (config: any) => void;
};

type EligibleTwitchTokenStatus =
  | 'loading'
  | 'error'
  | 'has-eligible'
  | 'not-eligible';

export const PredictionWidgetEdit = (props: Props) => {
  return (
    <>
      <TwitchManageSubscription />
      <div style={{marginTop: '40px'}} />
      <BasicFormElement
        label={'Trigger BPM'}
        description={
          'Widget will start the guess mode after trigger BPM is reached'
        }
      >
        <Form.Control
          type="number"
          value={props.configuration.triggerBPM}
          onChange={(e) =>
            props.onUpdate(
              set(props.configuration, 'triggerBPM', e.target.value)
            )
          }
        />
      </BasicFormElement>
      <div style={{marginTop: '40px'}} />
      <Action onClick={() => props.onSave(props.configuration)}>
        Save settings
      </Action>
    </>
  );
};

export const TwitchManageSubscription = () => {
  let client = usePulsoidClient();

  const [eligibilityStatus, setEligibilityStatus] =
    React.useState<EligibleTwitchTokenStatus>('loading');

  useEffect(() => {
    client
      .hasTwitchTokenByScope(['channel:manage:predictions'])
      .then((response) => {
        if (response) {
          setEligibilityStatus('has-eligible');
        } else {
          setEligibilityStatus('not-eligible');
        }
      })
      .catch(() => {
        setEligibilityStatus('error');
      });
  }, [eligibilityStatus]);

  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
        }}
      >
        <div className="form-label" style={{marginBottom: 0}}>
          Twitch Manage Prediction Status
        </div>

        <div
          style={{
            display: 'flex',
            gap: '10px',
            alignItems: 'center',
          }}
        >
          {eligibilityStatus === 'loading' && (
            <Spinner size="sm" animation="border" />
          )}
          {eligibilityStatus === 'error' && <Circle color="red" />}
          {eligibilityStatus === 'has-eligible' && <Circle color="green" />}
          {eligibilityStatus === 'not-eligible' && <Circle color="red" />}

          {eligibilityStatus === 'loading' && <div>Loading</div>}
          {eligibilityStatus === 'error' && <div>Error</div>}
          {eligibilityStatus === 'has-eligible' && <div>Connected</div>}
          {eligibilityStatus === 'not-eligible' && <div>Not connected</div>}
        </div>
        <div className="text-muted">
          {eligibilityStatus === 'loading' &&
            'Loading Twitch connection status'}
          {eligibilityStatus === 'error' &&
            'Error during fetching Twitch connection status'}
          {eligibilityStatus === 'has-eligible' &&
            'Pulsoid can start and end predictions on your twitch channel.'}
          {eligibilityStatus === 'not-eligible' &&
            'Pulsoid doesn’t have access to predictions on your twitch channel.'}
        </div>
        {eligibilityStatus === 'not-eligible' && (
          <div>
            <ButtonV2
              type="twitch"
              onClick={() => {
                window.location.href = AuthUrl();
              }}
            >
              Connect Twitch
            </ButtonV2>
          </div>
        )}
      </div>
    </div>
  );
};

const Circle = ({color}: {color: string}) => (
  <div
    style={{
      width: '10px',
      height: '10px',
      borderRadius: '50%',
      backgroundColor: color,
    }}
  ></div>
);

const AuthUrl = () =>
  buildUrl('https://pulsoid.net', {
    path: 'oauth/twitch/initiate',
    queryParams: {
      with_prediction_scope: 'true',
      redirect: window.location.href,
    },
  });
